import React from 'react';
import { useSeo } from '../hooks/useSeo';
import { Hero } from '../components/Hero';
import { DispatchCounter } from '../components/DispatchCounter';
import { FaqPreview } from '../components/FaqPreview';
import { UnderOneRoof } from '../components/UnderOneRoof';
import { DriveOrOffice } from '../components/DriveOrOffice';
import { BrokerVerification } from '../components/BrokerVerification';
import { CoreSupport } from '../components/CoreSupport';
import { NotJustBooking } from '../components/NotJustBooking';
import { CleanerOnboarding } from '../components/CleanerOnboarding';
import { FinalContact } from '../components/FinalContact';
import { ChatWidget } from '../components/ChatWidget';
export function Home() {
  useSeo({
    title: 'Truck Dispatch & Back Office Support for Owner-Operators | FSG Transport',
    description: 'FSG Transport provides U.S.-based truck dispatch, load planning, broker setup, paperwork, billing, and back-office support for owner-operators and small fleets.',
    path: '/'
  });
  return <div className="w-full" data-id="element-502">
      <Hero data-id="element-503" />
      <DispatchCounter data-id="element-504" />
      <FaqPreview data-id="element-505" />
      <UnderOneRoof data-id="element-506" />
      <DriveOrOffice data-id="element-507" />
      <BrokerVerification data-id="element-508" />
      <CoreSupport data-id="element-509" />
      <NotJustBooking data-id="element-510" />
      <CleanerOnboarding data-id="element-511" />
      <FinalContact data-id="element-512" />
      <ChatWidget data-id="element-513" />
    </div>;
}